import {API_URLS} from '@/const';
import {http} from '@/helper/http';

export const legendTradingApi = {
  checkGeo() {
    return http.get(API_URLS.OTC_LEGEND_GEO, {});
  },
  getParams() {
    return http.get(API_URLS.OTC_LEGEND_PARAMS, {});
  },
  checkKyc() {
    return http.get(API_URLS.OTC_KYC_CHECK, {});
  },
  legendKybStatus() {
    return http.get(API_URLS.KYB_LEGEND_STATUS, {});
  },
  legendKybStatusSendEmail() {
    return http.get(API_URLS.KYB_LEGEND_STATUS_NOTIFY, {});
  },
  submitLegendKyb() {
    return http.post(API_URLS.KYB_LEGEND_SUBMIT, {});
  },
  getKycApprovedStatus() {
    return http.get(API_URLS.OTC_KYC_APPROVED_STATUS, {});
  },
  /**
   * @returns {Promise<{ data?: Record<string, any>, error?: {code: string, message: string}, reply: Record<string, any>}>}
   */
  getKycApprovedStatusV2() {
    return http.get(API_URLS.OTC_KYC_APPROVED_STATUS_V2, {});
  },
  getLegendTradeHistory(query) {
    return http.get(API_URLS.BUY_CRYPTO_OTC_LEGEND_HISTORY, {query});
  },
  legendBanIpCheck(query) {
    return http.get(API_URLS.LEGEND_BAN_IP_CHECK, {query});
  },
};
